import { Moment } from 'moment';

export type ClsItem = {
  id?: number;
  sd?: Moment;
  ed?: Moment;
  status?: number;
  cls: number;
  parentNum?: number;
  parentClsNum?: string;
  type?: number;
  num: number;
  lang?: number;
  code?: string;
  term: string;
  dsc?: string;
  uref?: string;
  other?: unknown;
};

export type ObjIdentifier = {
  id?: number;
  sd?: Moment;
  ed?: Moment;
  cIdentSystem: string;
  cIdentSystemItem?: ClsItem;
  rObject?: string;
  identifier?: string;
};

enum cStatusEnum {
  '25:1' = 'active',
  '25:6' = 'unactive',
}

export enum cCommentStatusEnum {
  'deny' = '108:0',
  'allow' = '108:1',
}

export type cStatus = cStatusEnum;
export type cCommentStatus = cCommentStatusEnum;

export type ClsMapType = { [s: string]: ClsItem };